import { initialState } from './selectors';
import { AUTH_LOGIN_FAILURE, AUTH_LOGIN_REQUEST, AUTH_LOGIN_SUCCESS, AUTH_LOGOUT } from './actions';
import { getStoredAuthState } from './utils';

export default function reducer(
  state = Object.assign(initialState, getStoredAuthState()),
  { type, payload }
) {
  switch (type) {
    case AUTH_LOGIN_REQUEST:
      return {
        ...state,
        error: null,
      };
    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        user: payload,
      };
    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        error: payload,
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        user: null,
      };
    default:
      return state;
  }
}
